import Create from "./Create";
import Dashboard from "./Dashboard";
import List from "./List";
import Update from "./Update";

export const Events = {
  Dashboard: Dashboard,
  List: List,
  Update: Update,
  Create: Create,
  Permissions: {
    create: "create:Event",
    read: "read:Event",
    list: "list:Event",
    dashboard: "dashboard:Event",
    update: "update:Event",
    delete: "delete:Event",
  },
};
